<template>
    <div class="main">
        <div class="main--bumper-box" v-if="response.length">
            <!-- <SimplePageBuilder :response="response"></SimplePageBuilder> -->
            <div v-for="(component, index) in response" :key="index">
                <teaser
                    :fields="component.fields"
                    v-if="hideFreeCopy(component.fields.paragraph) && component.type === 'teaser'"
                />
            </div>
            <custom-button
                :size="buttonFields.size"
                label="Upgrade"
                :onClick="showBumperBoxPopup"
                :primary="buttonFields.primary"
                :backgroundColor="buttonFields.backgroundcolor"
                :bordered="buttonFields.bordered"/>
            <p class="box-info">{{$t('GIFTING_BUMPER_BOX_INFO')}}</p>
        </div>
        <transition name="transitionFade">
            <bumper-box-upgrade-modal
                v-if="showUpgradeModal"
                :selectedBox="selectedBox"
                :showMoreInfoLink="false"
                @closed="closeModal"/>
        </transition>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { Teaser, CustomButton } from '@freddiesflowers/frontend-component-library';
import { getButterCmsPage } from '@/helpers/ButterCmsHelpers';
import BumperBoxUpgradeModal from '@/components/partials/account/bumper-box/BumperBoxUpgradeModal';
import { FREE_HURRICANE_VASE } from '@/constants/Gifting';

export default {
    name: 'BumperBox',
    components: {
        Teaser, CustomButton, BumperBoxUpgradeModal,
    },
    data() {
        return {
            response: [],
            showUpgradeModal: false,
            boxSelected: 'bumper',
        };
    },
    created() {
        if (!this.$store.getters['account/getBumperBoxEnabled']) this.$router.push({ name: '404' });
        let page = process.env.VUE_APP_ENV === 'Production' ? 'bumper-box' : 'uat-bumper-box';
        getButterCmsPage(page).then((res) => this.response = res);
    },
    computed: {
        buttonFields() {
            return this.response?.filter(item => item.type === 'action_button')[0].fields || {};
        },
        reupgrade() {
            return this.activeSubscription?.products_received?.indexOf(FREE_HURRICANE_VASE) !== -1;
        },
        ...mapGetters({
            activeSubscription: 'subscription/getActiveSubscription',
            products: 'subscription/getProductTypes',
            boxPrice: 'register/getBoxPrice',
            deliveryPrice: 'register/getDeliveryPrice',
        }),
        selectedBox() {
            return this.products.filter(item => item.product_family === this.boxSelected)[0];
        },
    },
    methods: {
        showBumperBoxPopup() {
            this.showUpgradeModal = true;
        },
        closeModal() {
            this.showUpgradeModal = false;
        },
        hideFreeCopy(text) {
            return !text?.toLowerCase().includes('hurricane vase') || !this.reupgrade;
        },
    },
};
</script>

<style scoped lang="scss">
.main {
    margin: 0 auto;
    width: 90%;
    max-width: 700px;
    &--bumper-box {
        .button {
            margin: 20px auto;
            display: block;
        }
    }
}
.box-info{
    text-align: center;
    margin-bottom: 10px ;
    font-size: 15px;
}
</style>
